import loadable from '@loadable/component';
import React from 'react'
import CreateIcon from '../../Icons/Create';
import APIS from '../../constant/EndPoint';
import usePostHook from '../../customHooks/useTicketServicePostHook';
import useUserServiceGetHook from '../../customHooks/useGetHook';
const CreateTicketComponent = loadable(
  () => import("../../components/Ticket/CreateTicket")
);

const CreateTicket = () => {
  const { data: profile } = useUserServiceGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  console.log(profile)

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["ticket"],
    navigateURL: "/ticket",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.TICKET}`;
    let formData = {
      ...values,
      title: profile?.full_name
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Ticket</span>
      </div>
      <CreateTicketComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  )
}

export default CreateTicket
